export interface IComparison {
  name: string;
  pagePath: string;
  title: string;
  imageUrl: string;
  summary: string;
  summary_short: string;
  contents: {
    header: string;
    body: {
      title: string;
      description: string;
    }[];
    imageUrl: string;
  }[];
}

export const Comparisons: IComparison[] = [
  {
    name: 'LouiseBot VS Voiceflow',
    pagePath: 'louisebot-vs-voiceflow',
    title: 'Comparison/voiceflow/title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24120308054311_page_ai_vs_voiceflow.png',
    summary: 'Comparison/voiceflow/summary',
    summary_short: 'Comparison/voiceflow/summary-short',
    contents: [
      {
        header: 'Comparison/voiceflow/louiseBot/title',
        body: [
          {
            title: 'Comparison/voiceflow/louiseBot/h-01',
            description: 'Comparison/voiceflow/louiseBot/des-01',
          },
          {
            title: 'Comparison/voiceflow/louiseBot/h-02',
            description: 'Comparison/voiceflow/louiseBot/des-02',
          },
          {
            title: 'Comparison/voiceflow/louiseBot/h-03',
            description: 'Comparison/voiceflow/louiseBot/des-03',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711502888_LouiseBot_Dashboard.jpg',
      },
      {
        header: 'Comparison/voiceflow/competitor/title',
        body: [
          {
            title: 'Comparison/voiceflow/competitor/h-01',
            description: 'Comparison/voiceflow/competitor/des-01',
          },
          {
            title: 'Comparison/voiceflow/competitor/h-02',
            description: 'Comparison/voiceflow/competitor/des-02',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711561157_voiceflow.png',
      },
    ],
  },
  {
    name: 'LouiseBot VS Chatbot',
    pagePath: 'louisebot-vs-chatbot',
    title: 'Comparison/chatbot/title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24120308054239_page_ai_vs_chatbot.png',
    summary: 'Comparison/chatbot/summary',
    summary_short: 'Comparison/chatbot/summary-short',
    contents: [
      {
        header: 'Comparison/chatbot/louiseBot/title',
        body: [
          {
            title: 'Comparison/chatbot/louiseBot/h-01',
            description: 'Comparison/chatbot/louiseBot/des-01',
          },
          {
            title: 'Comparison/chatbot/louiseBot/h-02',
            description: 'Comparison/chatbot/louiseBot/des-02',
          },
          {
            title: 'Comparison/chatbot/louiseBot/h-03',
            description: 'Comparison/chatbot/louiseBot/des-03',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711502888_LouiseBot_Dashboard.jpg',
      },
      {
        header: 'Comparison/chatbot/competitor/title',
        body: [
          {
            title: 'Comparison/chatbot/competitor/h-01',
            description: 'Comparison/chatbot/competitor/des-01',
          },
          {
            title: 'Comparison/chatbot/competitor/h-02',
            description: 'Comparison/chatbot/competitor/des-02',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711561136_chatbot.png',
      },
    ],
  },
  {
    name: 'LouiseBot VS Chatbase',
    pagePath: 'louisebot-vs-chatbase',
    title: 'Comparison/chatbase/title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24120308054259_page_ai_vs_chatbase.png',
    summary: 'Comparison/chatbase/summary',
    summary_short: 'Comparison/chatbase/summary-short',
    contents: [
      {
        header: 'Comparison/chatbase/louiseBot/title',
        body: [
          {
            title: 'Comparison/chatbase/louiseBot/h-01',
            description: 'Comparison/chatbase/louiseBot/des-01',
          },
          {
            title: 'Comparison/chatbase/louiseBot/h-02',
            description: 'Comparison/chatbase/louiseBot/des-02',
          },
          {
            title: 'Comparison/chatbase/louiseBot/h-03',
            description: 'Comparison/chatbase/louiseBot/des-03',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711502888_LouiseBot_Dashboard.jpg',
      },
      {
        header: 'Comparison/chatbase/competitor/title',
        body: [
          {
            title: 'Comparison/chatbase/competitor/h-01',
            description: 'Comparison/chatbase/competitor/des-01',
          },
          {
            title: 'Comparison/chatbase/competitor/h-02',
            description: 'Comparison/chatbase/competitor/des-02',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711561137_Chatbase.jpg',
      },
    ],
  },
  {
    name: 'LouiseBot VS Botpress',
    pagePath: 'louisebot-vs-botpress',
    title: 'Comparison/botpress/title',
    imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24120308054294_page_ai_vs_botpress.png',
    summary: 'Comparison/botpress/summary',
    summary_short: 'Comparison/botpress/summary-short',
    contents: [
      {
        header: 'Comparison/botpress/louiseBot/title',
        body: [
          {
            title: 'Comparison/botpress/louiseBot/h-01',
            description: 'Comparison/botpress/louiseBot/des-01',
          },
          {
            title: 'Comparison/botpress/louiseBot/h-02',
            description: 'Comparison/botpress/louiseBot/des-02',
          },
          {
            title: 'Comparison/botpress/louiseBot/h-03',
            description: 'Comparison/botpress/louiseBot/des-03',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711502888_LouiseBot_Dashboard.jpg',
      },
      {
        header: 'Comparison/botpress/competitor/title',
        body: [
          {
            title: 'Comparison/botpress/competitor/h-01',
            description: 'Comparison/botpress/competitor/des-01',
          },
          {
            title: 'Comparison/botpress/competitor/h-02',
            description: 'Comparison/botpress/competitor/des-02',
          },
        ],
        imageUrl: 'https://cdn.1cdn.app/application/LOUISEBOT/24081711561148_botpress.png',
      },
    ],
  },
];
